<template>
  <div class="saving_info_wrap">
    <h5>{{ saleInfo.title }}</h5>
    <p>
      {{ saleInfo.content }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'SavingInfoComp',
  props: {
    saleInfo: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.saving_info_wrap {
  padding: 0 40px;
  h5 {
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 40px;
    color: #0b0b0d;
    line-height: 56px;
    font-weight: normal;
    span {
      color: #ff5f14;
      font-family: DiDiSans-Pro-ExtraBold;
      font-size: 40px;
      font-weight: normal;
    }
  }
  p {
    padding: 16px 0;
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    line-height: 42px;
    font-weight: 400;
  }
}
</style>
